module.exports = __webpack_public_path__ + "scaglie_pp@2x.jpg?7ebd54d09eca5bf67cf0feefc9540b16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scaglie_pp@2x.jpg
// module id = 254
// module chunks = 0